import { createAction } from '@reduxjs/toolkit';

export const sessionRecovered = createAction('auth/sessionRecovered');

export const userIdentityChanged = createAction<string | null>(
  'auth/userIdentityChanged',
);
